










































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, namespace } from 'vuex-class';
import { ChatState } from '@/store/chat/model';

import { analytics } from '@/common/gaHelper';
import MessageList from '@/components/LiveChat/MessageList.vue';
import LiveChatInput from '@/components/LiveChat/Input.vue';
import ChatRating from '@/views/Chatroom/ChatRating.vue';
import Header from '@/components/Header.vue';
import { emitOpenArticle, emitOpenMyRequest } from '@/common/eventBus';
import { sendToParrent, listenFromParent, platform, ParentEvDataVoicePermission, Bridge } from '@/common/bridge';
import FloatButton from './FloatButton.vue';
import RuleEngineHelper, { StepChangeEvent as RuleEngineStepChanged, StepRoute as RuleEngineStep } from './RuleEngineHelper/index.vue';
import BottomWrapper from './BottomWrapper.vue';
import { stepEnum } from '@/views/Chatroom/model';
import { FeedbackCategorie } from '@/model/pleased';
import Voice from '@/views/Chatroom/RuleEngineHelper/Voice.vue';
import PleasedChatClient from '@/vendor/pleased-sdk';

import * as PleasedApi from '@/common/api/api.pleased';
import * as PleasedModel from '@/common/api/models.pleased';
import * as env from '@/common/environment';
import * as Locale from '@/plugins/i18n';
import { reportingService } from '@/common/reporting';

import { BaseEvent, BaseMessage, BaseSystemMessage, ConnectToAgent, MessageConfiguration, MessageListItem, NoneOfTheAbove, SystemArticleMessage, SystemListMessage, UserTransactionMessage } from '@/common/bot/types';
import { createMessageHistory, createTypingMessage, EventType, ItemType, previewDetails, spawnSystemMessage, spawnUserSystemMessage, spawnCategoryListMessage, findMessageIndex, deleteMessage, generateResolutionIdFromArticle, BotConstants, canConnectToAgent, spawnResolutionMessage, getActionKeyFromCategoryName, getCategoryTitleFromMessageHistory, spawnSectionListMessage, createNotice, formatString, randomId, getSectionTitleFromMessageHistory, spawnUserTransactionMessage, hasMessage, spawnMessage, spawnMediaMessage } from '@/common/bot/lib';
import { MemberType, MessageType } from '@/common/bot/enum';
import { ConnectRequestEvent, PleasedUserInfo, TransactionInputEvent, VisitorInfoFilled, VisitorInformation } from '@/common/types';
import { TransactionType } from '@/common/config';
import ConversationHeader from './active-conversations/ConversationHeader.vue';
import ActiveConversations from './active-conversations/ActiveConversations.vue';
import { Conversation } from './active-conversations/type';
import formatDuration from 'date-fns/formatDuration';
import intervalToDuration from 'date-fns/intervalToDuration';
import { autoParse } from '@/common/pleased-parser';
import ThemeButton from '@/components/ThemeButton.vue';

let plsInstance: PleasedChatClient | null = null;
const chatModule = namespace('chat');
const userModule = namespace('user');

const SYSTEM_MESSAGE_PREFIX = 'Query:';

Component.registerHooks(['beforeRouteLeave']);

interface ActiveConversationState {
  total: number;
  conversations: Conversation[];
  selected?: Conversation | null;
  previousStep: stepEnum;
  backListener?: null | Function;
  clearListener?: null | VoidFunction;
  liveChatTicket?: string|number;
  route?: string;
}

function activeConversation (...states: Partial<ActiveConversationState>[]): ActiveConversationState {
  return Object.assign({
    total: 0, conversations: [], selected: null, previousStep: stepEnum.WaitRuleEngine, route: '', backListener: null,
  } as ActiveConversationState,
  ...states);
}

@Component({
  components: {
    Header,
    MessageList,
    FloatButton,
    RuleEngineHelper,
    LiveChatInput,
    BottomWrapper,
    ChatRating,
    ActiveConversations,
    ConversationHeader,
    ThemeButton,
  },
})
export default class Chatroom extends Vue {
  @userModule.State('token') token: any;
  @userModule.State('chatStatus') chatStatus!: string;
  @userModule.State('supportVoice') supportVoice!: boolean;
  @userModule.State('pleasedUser') pleasedUser!: PleasedUserInfo;
  @userModule.State('metaTags') metaTags!: Record<string, string|number|boolean>;
  @userModule.Mutation('updateAvatarImgUrl') updateAvatarImgUrl!: Function;
  @userModule.Mutation('updatePleasedUser') updatePleasedUser!: (payload: PleasedUserInfo) => void;
  $refs!: {
    index: HTMLElement,
    msgList: InstanceType<typeof MessageList>
  }
  stepEnum = stepEnum;
  currentStep = stepEnum['WaitRuleEngine'];
  // TODO: [voice dev]

  typing = false;

  actionableItemKey = 0; // 1 for deposits , 2 for withdrawals , 3 for bets , null otherwise
  visitorInfo: VisitorInformation = {
    displayName: '',
    email: '',
    phone: '',
  }
  showLoggedInOptions = {
    showCall: true,
    showLiveChat: true,
    showOpenRequest: false,
  }

  isGuestAllowed = false;
  ticketDescription = '';
  errInfo = { // For Bottom Wrapper
    isErr: false,
    message: '',
  };
  feedbackCategories: FeedbackCategorie[] = [];

  transactionMessage = '';

  activeConversations = activeConversation();
  cleanUps: Function[] = [];

  @State('chat') chatState!: ChatState;

  @chatModule.State('is_chatting') isChatting: any;
  @chatModule.State('is_ready_to_chat') isReadyToChat: any;
  @chatModule.State('chats') chats!: MessageListItem[];

  @chatModule.State('queue_position') queuePosition!: number;
  @chatModule.State('agentLeave') agentLeave!: boolean;

  @chatModule.State('hasSeenRate') hasSeenRate!: boolean;
  @chatModule.State('agentJoined') agentJoined!: boolean;
  @chatModule.State('extraTransactionInfo') extraTransactionInfo!: any;
  @chatModule.Getter('subject') subject!: string;
  @chatModule.Mutation('resetChat') resetChat!: Function;

  @chatModule.Mutation('updateHasSeenRate') updateHasSeenRate!: Function;
  @chatModule.Action('changeTypingList') changeTypingList!: Function;
  @chatModule.Action('readyToChat') readyToChat!: Function;
  @chatModule.State('showTyping') showTyping!: boolean;
  @userModule.Getter('displayName') displayName!: string;
  @userModule.State('isLogin') isLogin!: boolean;

  @userModule.State('country') country!: string;
  @userModule.State('customerAppVersion') customerAppVersion!: string | null;

  get isInlive () {
    return this.currentStep === stepEnum['LiveChatFlow'] && !this.agentLeave;
  }

  get showFloatButton () {
    return this.currentStep === stepEnum['ResolveEnd'] || this.currentStep === stepEnum['WaitRuleEngine'];
  }
  get messages () {
    const isActiveConversation = !!this.activeConversations.selected;

    let messages: any[] = [];
    isActiveConversation && messages.push(...this.activeConvoComments);

    if (this.messageList.length && !isActiveConversation) {
      messages.push(...this.messageList);
    }
    if (this.chats.length) {
      messages.push(...this.chats);
    }

    return messages;
  }
  get stickyMessages () {
    const messages = [];
    if (this.queuePosition > 0) {
      messages.push(
        createNotice({ message: this.$t('notice.queue_position', { queuePosition: this.queuePosition }) as string, id: 'queue-notice' }),
        createNotice({ message: this.$t('notice.waiting_for_agent') as string, id: 'waiting-for-agent-notice' })
      );
    }
    if (this.showTyping) {
      messages.push(BotConstants.STICKY_LOADING_MESSAGE);
    }
    return messages;
  }

  get consolidatedIssueMessage () {
    const messageIdx = findMessageIndex(this.messageList, { id: BotConstants.IDS.USER_ISSUE_LIST });
    if (messageIdx >= 0) {
      const message = this.messageList[messageIdx] as UserTransactionMessage;
      return message.issues.join(' / ');
    }
    return '';
  }

  get isAbleToSendMsg () {
    return this.isChatting && this.isReadyToChat;
  }

  get hideLanguageSelector () {
    return this.currentStep === stepEnum['LiveChatFlow'];
  }
  get processedUserSelectionMessages () {
    return this.messageList.filter(m => ItemType.isMessage(m) && m.sendToChat && m.message)
      .flatMap(m => {
        const item = m as BaseMessage;
        const timestamp = new Date(item.timestamp || Date.now()).valueOf();

        if (ItemType.isTransactionMessage(item) && item.issues?.length) {
          return item.issues.map(issue => {
            const message = `${item.message}: ${issue}`;
            const text = SYSTEM_MESSAGE_PREFIX && !item.noSystemPrefix ? `${SYSTEM_MESSAGE_PREFIX} ${message}` : message;
            return { timestamp, message: text };
          });
        }

        const text = SYSTEM_MESSAGE_PREFIX && !item.noSystemPrefix ? `${SYSTEM_MESSAGE_PREFIX} ${item.message}` : `${item.message}`;
        return { timestamp, message: text };
      });
  }

  get showConversationHeader () {
    const { currentStep, activeConversations } = this;
    return currentStep === stepEnum.WaitRuleEngine && activeConversations.total && !activeConversations.selected;
  }

  created () {
    reportingService.chatBotOpened();
    this.$router.replace('#').catch(() => {});
    this.initializeChatRoom();
    this.cleanUps.push(
      Locale.addListener(this.onLanguageChange),
      Bridge.onOpenActiveConversation(this.showConversation)
    );
  }

  beforeDestroy () {
    this.cleanUps?.forEach(c => { try { c?.(); } finally {} });
    if (plsInstance) {
      (plsInstance as any).disableTypingListener && (plsInstance as any).disableTypingListener();
    }
  }

  onLanguageChange () {
    if (this.currentStep === stepEnum['WaitRuleEngine'] || this.currentStep === stepEnum['ActiveConversation']) {
      // Reset chat.
      this.messageList = [];
      this.initializeChatRoom();
    } else if (this.currentStep === stepEnum['RuleEngine']) {
      this.messageList.push(createNotice({ message: this.t('notice.language_change', { locale: Locale.getCurrentLanguageName() }, 'Language changed to {locale}',) }));
    }
  }

  async setupPleasedChatTokens (client: PleasedChatClient) {
    return client.init({
      access_token: this.pleasedUser.token,
      pleased_url: env.get('url'),
      brand_subdomain: env.get('brandCode'),
    });
  }

  async postInit (isVoice = false) {
    await this.setupPleasedChatTokens(plsInstance as PleasedChatClient);

    const visitorInfo = {
      display_name: this.displayName ? this.displayName : this.visitorInfo.displayName,
      foreign_id: `${this.pleasedUser.foreignId}`,
      phone: this.pleasedUser.phone || this.visitorInfo.phone || '',
      email: this.visitorInfo.email || this.pleasedUser.email,
      customerAppVersion: this.customerAppVersion || '',
      ticketId: this.activeConversations.selected?.id,
      chatTags: Object.entries({
        ...this.metaTags,
        language: this.$i18n.locale, // override the language tag.
      }).filter(([, v]) => (v || '').trim()).map(([k, v]) => `${k}=${v.trim()}`),
      subject: this.ticketDescription || this.ticketSubject,
    };

    plsInstance?.setVisitorInfo(visitorInfo, (err: any) => {
      if (err) { console.error('[setVisitorInfo]: ', err); }
    }, isVoice);

    if (!isVoice) { // Request for live chat.
      // Show feedback categories only on Live chat.
      plsInstance?.getFeedbackOption().then((res: FeedbackCategorie[]) => {
        this.feedbackCategories = res;
      });

      const events = [
        'account_status',
        'connection_update',
        'department_update',
        'visitor_update',
        'agent_update',
        'chat',
        'error',
      ];

      events.forEach((evt) => {
        plsInstance?.on(evt, (data: any) => {
          if (!plsInstance) return;
          this.$store.dispatch({
            type: `chat/${evt}`,
            detail: data,
          });
        });
      });

      plsInstance?.on('onTypingListChange', (data:{ isTyping: boolean; displayName: string; isAgent: boolean }) => {
        if (!plsInstance) return;
        this.changeTypingList(data);
      });
      plsInstance?.on('ready_to_chat', () => {
        if (!plsInstance) return;
        this.readyToChat(true);
      });
    }
  }

  /**
   * Event when the rule engine step changes.
   * @event RuleEngineHelper#step:changed
   */
  onRuleEngineStepChange ({ step }: RuleEngineStepChanged) {
    // Send a transaction message before transaction screen is shown.
    if (this.transactionMessage && step === RuleEngineStep.Transaction) {
      if (!hasMessage(this.messageList, { id: BotConstants.IDS.TRANSACTION_MESSAGE_ID })) {
        this.messageList.push(
          spawnSystemMessage({
            type: MessageType.DEFAULT,
            message: this.transactionMessage,
            id: BotConstants.IDS.TRANSACTION_MESSAGE_ID,
          })
        );
      }
    }
  }

  /**
   * Event after the user has selected transaction/s (issue/s).
   * @event RuleEngineHelper#transaction:input
   */
  onTransactionInput ($event: TransactionInputEvent) {
    const { type, none, issues } = $event;
    const message = none ? {
      [TransactionType.Deposit]: this.t('chat.user.issue.different.deposit'),
      [TransactionType.Withdrawal]: this.t('chat.user.issue.different.withdraw'),
      [TransactionType.Bet]: this.t('chat.user.issue.different.bet'),
    }[type] : issues.length ? this.t('chat.user.issue.part') : this.t('chat.user.issue.no_records');

    this.messageList.push(
      spawnUserTransactionMessage({
        issues,
        message,
        id: BotConstants.IDS.USER_ISSUE_LIST,
      }),
      spawnSystemMessage({
        type: MessageType.DEFAULT,
        message: this.t('chat.sys.issue.ask_detail'),
        id: BotConstants.IDS.ISSUE_SYSTEM_DESCRIBE_ISSUE,
      }),
    );
  }

  /**
   * Event when the user requests to connect to the agent.
   * @event RuleEngineHelper#connect:request
   */
  onConnectRequest ($event: ConnectRequestEvent) {
    const { type, payload } = $event;
    if (type === 'openRequest') {
      const messages = [
        spawnUserSystemMessage({
          message: this.t('chat.user.response.action', { action: this.t('page.connect.open_request.text') }),
          id: BotConstants.IDS.USER_OPEN_TICKET,
          sendToChat: false,
        }),
        spawnSystemMessage({
          type: MessageType.DEFAULT,
          message: this.t('page.connect.open_request.created', { requestId: payload.ticketId || '' }),
          id: BotConstants.IDS.SYSTEM_REQUEST_SUCCESS,
        }),
        spawnSystemMessage({
          type: MessageType.DEFAULT,
          message: this.t('page.connect.open_request.end_message'),
          id: BotConstants.IDS.SYSTEM_REQUEST_RESPONSE,
        }),
      ];
      // This is a special type. The ticket is already created by the
      // inner components, so only messages needs to be appended here.
      this.messageList.push(...messages);
    } else if (type === 'chat') {
      this.messageList.push(spawnUserSystemMessage({
        message: this.t('chat.user.response.action', { action: this.t('page.connect.live_chat') }),
        id: BotConstants.IDS.USER_LIVE_CHAT,
        sendToChat: false,
      }));
      // Start the live chat flow.
      this.startLiveChat({ description: payload.description || '' });
    } else if (type === 'voice') {
      // Here, no messages are required, directly start the voice chat flow.
      this.handleVoice({ description: payload.description || '' });
    } else if (type === 'addComment') {
      // Show add comment for active conversation.
      this.currentStep = stepEnum.AddComment;
    }
  }

  /**
   * @event RuleEngineHelper#login:successful
   */
  onLoginSuccessful () {
    // Add a message from the system regarding the login details.
    const message = spawnSystemMessage({
      type: MessageType.DEFAULT,
      id: BotConstants.IDS.LOGGED_IN_BY,
      message: this.$t('chat.sys.login.success', { name: this.displayName }) as string,
    });
    this.messageList = [...deleteMessage(this.messageList, message), message];
  }

  /**
   * @event RuleEngineHelper#visitor:info
   */
  onVisitorInfoFilled ($event: VisitorInfoFilled) {
    const { visitorInfo, description } = $event;
    this.setVisitorInfo(visitorInfo);
    // Add messages describing the information from the user.
    // email, phone, name, description.
    let { displayName, email, phone = '', name = '' } = visitorInfo;
    name = name || displayName;

    email && this.messageList.push(spawnUserSystemMessage({
      message: this.t('chat.user.info.email', [email]),
      id: BotConstants.IDS.USER_EMAIL,
    }));

    phone && this.messageList.push(spawnUserSystemMessage({
      message: this.t('chat.user.info.phone', [phone]),
      id: BotConstants.IDS.USER_PHONE,
    }));

    name && this.messageList.push(spawnUserSystemMessage({
      message: this.t('chat.user.info.name', [name]),
      id: BotConstants.IDS.USER_DISPLAY_NAME,
    }));

    description && this.messageList.push(spawnUserSystemMessage({
      message: this.t('chat.user.info.issue_description', [description]),
      id: BotConstants.IDS.USER_DESCRIPTION,
      noSystemPrefix: true,
    }));

    this.messageList.push(spawnSystemMessage({
      type: MessageType.DEFAULT,
      message: this.t('chat.sys.message.connect'),
      id: BotConstants.IDS.HOW_TO_GET_IN_TOUCH,
    }));
  }
  // new props
  messageList: MessageListItem[] = [];
  stickyMessageList: MessageListItem[] = [];
  /**
   * List of messages to show on active conversation.
   */
  activeConvoComments: MessageListItem[] = [];
  brandConfig: PleasedModel.BrandConfig | Record<string, any> = {};
  ticketSubject = '';
  /**
   * A message for the initial list of categories. This is kept in memory to use with the
   * component `<FloatButton />`.
   */
  categoryMessage: SystemListMessage | null = null;
  atomicInitializeChatRoomCall: Function | null = null;
  // new methods
  async initializeChatRoom () {
    this.atomicInitializeChatRoomCall?.();
    let ignore = false;
    this.atomicInitializeChatRoomCall = () => { ignore = true; };

    const categoryMessageFuture = PleasedApi.getBrandConfig({ brandCode: env.get('brandCode') }).then(response => {
      if (!ignore) { this.brandConfig = response.data.brandConfig; }
      return spawnCategoryListMessage({
        message: response.data.brandConfig.showWelcomeMessage ? response.data.brandConfig.welcomeMessage : '',
        options: response.data.categories,
        id: 'category-base',
      });
    });
    const userConfigFuture = this.token ? PleasedApi.getPleasedTokenFromSportyToken({ countryCode: this.country, sportyToken: this.token }) : Promise.resolve(null);
    const categoryFuture = this.token ? (categoryMessageFuture) : this.apiMessage(categoryMessageFuture, { cancel: () => ignore });

    const [categoryMessage, userConfig] = await Promise.all([categoryFuture, userConfigFuture]);

    if (ignore) return;

    categoryMessage && (this.categoryMessage = categoryMessage);

    if (userConfig) {
      this.setupUserConfig(userConfig);
      this.resolveActiveConversation();
    }
  }

  setupUserConfig (config?: PleasedModel.UserInformation, isGuest = false) {
    if (config) {
      const { id, phone, email, foreignId, token, defaultName, name } = config;
      this.updatePleasedUser({ userId: id, phone, email: email || '', foreignId, token, displayName: name || defaultName || phone, isGuest });
    }
  }

  /**
   * Helper to show resolution if the chat has come to an end.
   */
  addResolutionMessage (message: BaseSystemMessage) {
    // If a resolution exists for the given resolution id, we delete the previous resolution and
    // append a new resolution for the same.
    this.messageList = [...deleteMessage(this.messageList, message), message];
  }

  endMessageFlow (positive: boolean) {
    // TODO: End the chat directly.
    this.messageList.push(spawnSystemMessage({ message: this.$t('chat.sys.goodbye') as string, type: MessageType.DEFAULT }));
    this.currentStep = stepEnum['ResolveEnd'];
  }

  /**
   * When we want to start the connect to agent flow.
   */
  connectToAgentFlow (config: ConnectToAgent, { category, sectionName = '' }: {category: string, sectionName?: string}) {
    this.showLoggedInOptions = {
      // No call if the device does not support it.
      // showCall: config.voiceChat && this.supportVoice && PleasedChatClient.isVoiceChatSupported,
      // Instead of adding support for each individual iOS version, we will directly rely on underlying
      // detection system, checking for window.RTCPeerConnection & getUserMedia.
      // TODO: Check with enabling this patch first and then switch to individual version of
      // OS, we can see which versions this method supports and just enable their support.
      showCall: config.voiceChat && PleasedChatClient.isVoiceChatSupported,
      showLiveChat: config.liveChat,
      showOpenRequest: !!config.openRequest,
    };
    const transactionType = getActionKeyFromCategoryName(category);
    // A login is explicitly required, iif a transaction list needs to be shown.
    const loginRequired = config.loginRequired; // || transactionType > 0;
    // This key is for transactions
    this.actionableItemKey = transactionType;
    this.isGuestAllowed = !loginRequired;

    this.ticketSubject = category + (sectionName.trim().length ? `+ ${sectionName}` : '');

    // If there is a transaction message to show.
    this.transactionMessage = config.transactionMessage || '';

    // Add a message for login message.
    if (!this.isLogin) {
      this.messageList.push(spawnSystemMessage({
        type: MessageType.DEFAULT,
        message: (loginRequired ? this.$t('chat.sys.login.required') : this.$t('chat.sys.login.optional')) as string,
      }));
    }
    // Switch to rule engine
    this.currentStep = stepEnum.RuleEngine;
  }

  /**
   * A message event is a message specific chat bot event. The different types
   * of messages (`MessageType.ts`) and events `SystemEvents.ts`.
   *
   * @event MessageList#message:input
   * @event FloatButton#message:input
   */
  async messageEvent ($event: BaseEvent) {
    if (this.currentStep !== stepEnum['WaitRuleEngine']) {
      return;
    }

    // console.info('evt', $event);

    if (EventType.isResolutionEvent($event)) {
      const { message: { config }, message } = $event;
      const resolved = $event.payload.selected === 'yes';
      const userMessage = spawnUserSystemMessage({ message: (resolved ? this.$t('global.yes') : this.$t('global.no')) as string });
      this.messageList.push(userMessage);
      if (resolved) {
        this.endMessageFlow(resolved);
      } else if (config && config.connect?.connect) {
        this.connectToAgentFlow(config.connect, {
          category: getCategoryTitleFromMessageHistory(message.history),
          sectionName: getSectionTitleFromMessageHistory(message.history),
        });
      } else {
        this.endMessageFlow(resolved);
      }
    } else if (EventType.isNoneOfTheAboveEvent($event)) {
      const { message: { config, id }, message } = $event;
      if (config && config.noneOfTheAbove && config.noneOfTheAbove?.config) {
        const { resolution } = config.noneOfTheAbove?.config || {};
        const { showResponseMessage = false, responseMessage = '' } = config.noneOfTheAbove || {};
        if (showResponseMessage && responseMessage) {
          this.messageList.push(spawnSystemMessage({
            type: MessageType.DEFAULT,
            id: `none-of-above-${randomId()}`,
            message: responseMessage,
          }));
        }
        this.resolveFlow(config.noneOfTheAbove?.config, spawnResolutionMessage({
          id: `${id}-none-of-the-above`,
          message: resolution?.message || this.t('chat.sys.resolution.default'),
          history: createMessageHistory($event, message),
          config: config?.noneOfTheAbove?.config,
        }));
      }
    } else if (EventType.isRollbackEvent($event)) {
      const index = this.messageList.indexOf($event.message);
      this.messageList = this.messageList.slice(0, index);
    } if (EventType.isArticleExpandedEvent($event)) {
      const { message: { article, config }, message } = $event;
      emitOpenArticle({ isOpen: true, title: article.title, articleId: article.id, body: article.body, sectionTitle: article.sectionTitle || '' });
      // Add resolution message.
      config && this.resolveFlow(config, spawnResolutionMessage({
        config,
        history: createMessageHistory($event, message), // propagate history of message if not specified.
        id: generateResolutionIdFromArticle(message), // Resolutions need a unique id.
        message: config.resolution?.message || this.t('chat.sys.resolution.default'),
      }));
    } else if (EventType.isOptionEvent($event)) {
      if ($event.message.type === MessageType.CATEGORIES_LIST) {
        const { payload: { selected: category }, message } = $event;
        this.messageList.push(spawnUserSystemMessage({
          sendToChat: true,
          message: this.$t('chat.user.response.message.text', { name: category.title }) as string,
          interactiveMessageParts: [this.$t('chat.user.response.message.part', { name: category.title }) as string, category.title],
          history: createMessageHistory($event, message),
        }));

        reportingService.selectedCategory(category.id);

        const futureMessage = PleasedApi.getCategoryDetails.cached({ categoryId: category.id }).then(({ data: { id: sectionId, categoryConfig, sections, noneOfTheAboveConfig } }) => spawnSystemMessage<SystemListMessage>({
          type: MessageType.SECTION_LIST,
          id: `section-${sectionId}`,
          options: sections,
          config: {
            noneOfTheAbove: {
              show: noneOfTheAboveConfig.noneOfTheAbove && noneOfTheAboveConfig.showToEndUser,
              // showResponseMessage: noneOfTheAboveConfig.showResponse,
              showResponseMessage: !!noneOfTheAboveConfig.responseMessage,
              responseMessage: noneOfTheAboveConfig.responseMessage,
              config: {
                connect: {
                  connect: noneOfTheAboveConfig.connectToAgent,
                  loginRequired: noneOfTheAboveConfig.loginRequired,
                  liveChat: noneOfTheAboveConfig.showLiveChat,
                  openRequest: noneOfTheAboveConfig.showOpenRequest,
                  voiceChat: noneOfTheAboveConfig.showVoiceChat,
                  transactionMessage: noneOfTheAboveConfig.transactionMessage,
                },
                resolution: {
                  show: noneOfTheAboveConfig.showEndMessage,
                  message: noneOfTheAboveConfig.endMessage || '',
                },
              },
            },
          },
          message: categoryConfig.responseMessage || '',
          history: createMessageHistory($event, message),
        }));

        // Check for trigger
        this.apiMessage(this.runWithOverlayTriggerCheck(futureMessage, 'CATEGORY', category.id));
      } else if ($event.message.type === MessageType.SECTION_LIST) {
        const { payload: { selected: section }, message } = $event;
        const userMessage: BaseMessage = spawnUserSystemMessage({
          message: this.t('chat.user.response.message.text', { name: section.title }),
          interactiveMessageParts: [this.t('chat.user.response.message.part'), section.title],
          history: createMessageHistory($event, message),
        });
        this.messageList.push(userMessage);

        reportingService.selectedSection(section.id);

        // Determine if the section is 1st level, i.e. right after the category message.
        const isFirstLevelSection = message.config && !message.config.connect;

        const futureMessage = PleasedApi.getSectionDetails.cached({ sectionId: section.id }).then(({ data: { sectionConfig, sections, noneOfTheAboveConfig, articles } }) => {
          // First level sections use their own config.
          const overrideParentConfig = sectionConfig.overrideParentConfig || isFirstLevelSection;
          const overrideNoneOfTheAbove = noneOfTheAboveConfig.overrideParentConfig || isFirstLevelSection;

          // Tread noneOfTheAbove as section.
          const noneOfTheAbove: NoneOfTheAbove = {
            // explicitly hide none of the above on sections.
            show: noneOfTheAboveConfig.noneOfTheAbove && noneOfTheAboveConfig.showToEndUser && !!sections.length,
            showResponseMessage: overrideNoneOfTheAbove ? !!noneOfTheAboveConfig.responseMessage : !!message.message,
            responseMessage: overrideNoneOfTheAbove ? noneOfTheAboveConfig.responseMessage : message.message,
            config: overrideNoneOfTheAbove ? {
              connect: {
                connect: noneOfTheAboveConfig.connectToAgent,
                loginRequired: noneOfTheAboveConfig.loginRequired,
                liveChat: noneOfTheAboveConfig.showLiveChat,
                openRequest: noneOfTheAboveConfig.showOpenRequest,
                voiceChat: noneOfTheAboveConfig.showVoiceChat,
                transactionMessage: noneOfTheAboveConfig.transactionMessage,
              },
              resolution: {
                show: noneOfTheAboveConfig.showEndMessage,
                message: noneOfTheAboveConfig.endMessage || '',
              },
            } : { connect: message.config?.connect, resolution: message.config?.resolution },
          };
          const config = overrideParentConfig ? {
            noneOfTheAbove,
            connect: {
              connect: sectionConfig.connectToAgent,
              loginRequired: sectionConfig.loginRequired,
              liveChat: sectionConfig.showLiveChat,
              openRequest: sectionConfig.showOpenRequest,
              voiceChat: sectionConfig.showVoiceChat,
              transactionMessage: sectionConfig.transactionMessage,
            },
            resolution: {
              show: sectionConfig.showEndMessage,
              message: sectionConfig.endMessage || '',
            },
          } : { ...message.config, noneOfTheAbove };
          const responseMessage = overrideParentConfig ? sectionConfig.responseMessage || '' : message.message;
          const messageToShow = spawnSystemMessage<SystemListMessage>({
            type: sections.length ? MessageType.SECTION_LIST : MessageType.ARTICLE_LIST,
            config,
            options: (sections.length ? sections : articles),
            message: responseMessage,
            history: createMessageHistory($event, message, userMessage),
          });
          return messageToShow;
        });

        this.apiMessage(this.runWithOverlayTriggerCheck(futureMessage, 'SECTION', section.id));
      } else if ($event.message.type === MessageType.ARTICLE_LIST) {
        const { payload: { selected: article }, message } = $event;

        reportingService.selectedArticle(article.id);

        const futureMessage = PleasedApi.getArticleDetails.cached({ articleId: article.id }).then(({ data: { title, body: articleHtml, id, articleConfig = {} } }) => {
          const { isPreview, preview, body } = previewDetails(articleHtml);
          return spawnSystemMessage<SystemArticleMessage>({
            id: `article-${id}`,
            type: isPreview ? MessageType.ARTICLE_PREVIEW : MessageType.ARTICLE_FULL,
            // The config from the initial message is forwarded to the article message.
            config: message.config,
            // message: articleConfig.showResponse ? articleConfig.responseMessage || '' : '',
            message: articleConfig.responseMessage || '',
            history: createMessageHistory($event, message),
            article: {
              body,
              id,
              title,
              preview,
              // The sectionTitle is the category from which this message originated, modify the title here.
              sectionTitle: getCategoryTitleFromMessageHistory(message.history, title),
            },
          });
        });

        const overlayFuture = this.runWithOverlayTriggerCheck(futureMessage, 'ARTICLE', article.id);

        const resolvedMessage = await this.apiMessage(overlayFuture);

        // If this is not a preview, we have to show the resolution message.
        if (resolvedMessage && resolvedMessage.type === MessageType.ARTICLE_FULL) {
          resolvedMessage.config && this.resolveFlow(resolvedMessage.config, spawnResolutionMessage({
            history: resolvedMessage.history || [], // propagate history of message if not specified.
            id: generateResolutionIdFromArticle(resolvedMessage), // Get the id from resolution message.
            message: resolvedMessage.config?.resolution?.message || this.$t('chat.sys.resolution.default') as string,
            config: resolvedMessage.config,
          }));
        }
      }
    }
  }

  resolveFlow (config: MessageConfiguration, resolutionMessage: BaseSystemMessage) {
    if (config.resolution?.show) {
      this.addResolutionMessage(resolutionMessage);
    } else if (canConnectToAgent(config.connect)) {
      this.connectToAgentFlow(config.connect, {
        category: getCategoryTitleFromMessageHistory(resolutionMessage.history),
        sectionName: getSectionTitleFromMessageHistory(resolutionMessage.history),
      });
    } else {
      this.endMessageFlow(true);
    }
  }

  /**
   * Asynchronously runs the given promise `supplier` while simultaneously checking for any overlay triggers that need to be executed.
   * The method accepts a `type` parameter, which indicates the type of trigger to check for and an `id` parameter which provides the corresponding id for the trigger.
   * If any triggers are found, the user is presented with a dialog box with the trigger message and given the option to either end the chat or continue.
   * The method returns a promise that resolves with the result of the `supplier` promise once both the supplier and overlay trigger checks have completed.
   * If there are no triggers to execute, the `supplier` promise is returned immediately.
   */
  async runWithOverlayTriggerCheck<T> (supplier: Promise<T>, type: 'CATEGORY' | 'ARTICLE' | 'SECTION', id: number|string): Promise<T> {
    const overlayTrigger = PleasedApi.matchOverlayTrigger.cached({ type, id: +id }).then(matchedTrigger => {
      if (!matchedTrigger?.message?.length) return;
      const { chatTriggerId, message } = matchedTrigger;
      const triggerDialog = this.$dialog({
        content: message,
        className: 'overlay-trigger',
        buttons: [{
          name: this.$t('global.end_chat'),
          callback: async () => {
            await PleasedApi.trackOverlyClick({ type: 'END_CHAT', chatTriggerId }).catch(() => {});
            triggerDialog.close();
            this.handleEndChat();
          },
        }, {
          name: this.t('global.continue', 'Continue'),
          class: 'primary',
          callback: () => {
            PleasedApi.trackOverlyClick({ type: 'CONTINUE', chatTriggerId });
            triggerDialog.close();
          },
        }],
      });
    }).catch(() => {});

    return Promise.all([supplier, overlayTrigger]).then(([result]) => result);
  }

  /**
   * Helper utility that will create a loading message while the API is getting called and will
   * replace the loading message with the message from the promise.
   */
  async apiMessage <T extends MessageListItem> (futureMessage: Promise<T[]> | (() => Promise<T[]>), options?: {removeExisting?: boolean, fromUser?: boolean; cancel?: () => boolean}): Promise<T[]|null>;
  // eslint-disable-next-line no-dupe-class-members
  async apiMessage <T extends MessageListItem> (futureMessage: Promise<T> | (() => Promise<T>), options?: {removeExisting?: boolean, fromUser?: boolean; cancel?: () => boolean}): Promise<T|null>;
  // eslint-disable-next-line no-dupe-class-members
  async apiMessage <T extends MessageListItem> (futureMessage: Promise<T|T[]> | (() => Promise<T|T[]>), { removeExisting = false, fromUser = false, cancel }: {removeExisting?: boolean, fromUser?: boolean; cancel?: () => boolean} = {}): Promise<T|T[]|null> {
    const loading = createTypingMessage(null, fromUser ? MemberType.VISITOR : MemberType.AGENT);
    this.messageList.push(loading);
    try {
      const message = await (typeof futureMessage === 'function' ? futureMessage() : futureMessage);
      if (cancel?.()) {
        this.messageList = deleteMessage(this.messageList, loading);
        return null;
      }
      const messages = Array.isArray(message) ? message : [message];
      if (removeExisting) {
        // remove a existing message of the same id, if specified.
        messages.forEach(m => (this.messageList = deleteMessage(this.messageList, m)));
      }
      const loadingIdx = findMessageIndex(this.messageList, loading);

      const hasLoading = loadingIdx >= 0;
      const messageList = [...this.messageList];
      messageList.splice(hasLoading ? loadingIdx : messageList.length, hasLoading ? 1 : 0, ...messages);
      this.messageList = messageList;

      return message;
    } catch (e) {
      // TODO: Handle error
      this.messageList = deleteMessage(this.messageList, loading);
      console.error('API message error:', e);
    }
    return null;
  }

  handleOnSubmit (msg: string) {
    this.stopTyping();
    plsInstance?.sendChatMsg(msg, (err: any) => {
      if (err) {
        console.error('[sendChatMsg]: ', err);
      }
    });
    const timestamp = this.chatState.last_timestamp + 1;
    this.$store.dispatch({
      type: 'chat/chat',
      detail: {
        type: 'chat.msg',
        display_name: this.chatState.visitor.display_name,
        nick: this.chatState.visitor.nick || 'visitor:',
        timestamp,
        msg,
        source: 'local',
      },
    });
  }
  async handlePleasedChat () {
    await plsInstance?.endChat();
    plsInstance?.disablePleasedTypingListener();
  }
  async handleEndChat () {
    // Reset the State before Leave
    if (this.currentStep === stepEnum['LiveChatFlow'] && !this.hasSeenRate && this.agentJoined) {
      this.currentStep = stepEnum['ChatRating'];
      this.updateHasSeenRate(true);
      await this.handlePleasedChat();

      this.resetChat();
      return;
    }
    sendToParrent('CLEAR_FLOAT');
    if (this.currentStep === stepEnum['LiveChatFlow']) {
      await this.handlePleasedChat();
    }
    this.resetChat();
    reportingService.reset();
    sendToParrent('CLOSE');
  };
  handleOnTyping (message: string) {
    if (!this.typing) {
      plsInstance?.sendTypingPleased(message);
    }
  }
  stopTyping () {
    if (!this.typing) return;
    plsInstance?.sendTyping(false);
    this.typing = false;
  }
  handleFileUpload (file: any, attachment: any) {
    plsInstance?.sendFile(file, (err: any) => {
      if (err) {
        console.error('err: ', err);
        const dialog = this.$dialog({
          content: 'File is not appropriate to upload',
          buttons: [{
            name: 'OK',
            callback: () => { dialog.close(); },
          }],
        });
        return;
      }
      const timestamp = this.chatState.last_timestamp + 1;
      this.$store.dispatch({
        type: 'chat/chat',
        detail: {
          type: 'chat.file',
          display_name: this.chatState.visitor.display_name,
          nick: this.chatState.visitor.nick || 'visitor:',
          timestamp,
          attachment,
          source: 'local',
        },
      });
    });
  }

  startLiveChat (data = { description: '' }) {
    this.readyToChat(false); // reset the state
    this.ticketDescription = data.description;

    plsInstance = new PleasedChatClient();
    this.postInit();
    this.currentStep = stepEnum['LiveChatFlow'];

    const queueMsgs = this.messageList.filter(m => ItemType.isMessage(m) && m.message && m.sendToChat).map((m) => {
      const message = m as BaseMessage;
      const text = ItemType.isTransactionMessage(message) && message.issues?.length ? `${message.message} ${message.issues.join(', ')}` : message.message;
      return SYSTEM_MESSAGE_PREFIX && !message.noSystemPrefix ? `${SYSTEM_MESSAGE_PREFIX} ${text}` : text;
    });

    if (this.activeConversations.selected) {
      plsInstance?.sendChatMsg(this.$t('chat.user.response.action', { action: 'Live Chat' }) as string, (err: any) => err && (console.error('[sendChatMsg]: ', err)));
      this.activeConversations = activeConversation(this.activeConversations, { liveChatTicket: this.activeConversations.selected.id });
      this.activeConvoComments = [...this.activeConvoComments, createNotice({ message: 'Please do not close this window, doing so will end this live conversation.' })];
    }
    queueMsgs.length && queueMsgs.reduce((p: Promise<void>, msg: string) =>
      p.then(() => new Promise<void>(resolve => {
        plsInstance?.sendChatMsg(msg, (err: any) => {
          if (err) {
            console.error('[sendChatMsg]: ', err);
          }
          resolve();
        }, true);
      },
      ))
    , Promise.resolve());
  }

  setVisitorInfo (visitorInfo: VisitorInformation) {
    this.visitorInfo = visitorInfo;
  }
  scrollMsgListToEnd () {
    this.$refs?.msgList?.scrollToEnd();
  }
  postFeedback (config: {rating: string, comment: string, feedbackSelectionIds: string}) {
    const { rating, comment, feedbackSelectionIds } = config;

    (plsInstance)?.postFeedback({
      rating,
      comment,
      feedbackSelectionIds,
    });
  }
  handleFeedback (config: {rating: string, comment: string, feedbackSelectionIds: string}) {
    const dialog = this.$dialog({ content: this.$t('page.feedback.thanks') as string, className: 'thanks-class' });

    setTimeout(() => {
      dialog.close();
      sendToParrent('CLEAR_FLOAT');
      sendToParrent('CLOSE');
    }, 2000);

    this.postFeedback(config);
  }
  async handleVoice (data = { description: '' }) {
    const { description } = data;
    const checkPermissionDialog = new Promise((resolve) => {
      if (platform === 'app') {
        listenFromParent<ParentEvDataVoicePermission>('APP_HAS_VOICE_PERMISSION', data => {
          if (data.permission) {
            resolve(true);
          } else {
            resolve(false);
            const dialogPermison = this.$dialog({
              // TODO: [Sportybet]
              title: this.$t('page.voice.permission.title', { appName: env.get('appName') }) as string,
              // TODO: [Sportybet]
              content: this.t('page.voice.permission.reason', { appName: env.get('appName') }),
              className: 'dialog-voice-permission',
              buttons: [{
                name: this.t('page.voice.permission.not_now'),
                callback: () => {
                  dialogPermison.close();
                },
              }, {
                name: 'Ok',
                callback: () => {
                  dialogPermison.close();
                  sendToParrent('APP_GO_SETTING');
                },
              }],
            });
          }
        });
        sendToParrent('APP_HAS_VOICE_PERMISSION');
      } else {
        resolve(true);
      }
    });
    const dialog1 = this.$dialog({
      content: this.t('page.voice.disclaimer'),
      buttons: [{
        name: this.t('page.voice.cancel'),
        callback: () => { dialog1.close(); },
      }, {
        name: 'Call',
        class: ['primary'],
        callback: async () => {
          const res = await checkPermissionDialog;
          if (!res) {
            dialog1.close();
            return;
          };
          plsInstance = new PleasedChatClient();
          dialog1.loading(true);
          await this.postInit(true);
          dialog1.loading(false);

          const dialog2 = this.$dialog({
            content: <Voice
              onCall={async (voiceComponent?: Voice) => {
                try {
                  const isGuest = !this.isLogin;
                  const guestObj = { // phone, email will be null in PleasedChatClient if is Geust
                    phone: this.visitorInfo.phone,
                    email: this.visitorInfo.email,
                  };
                  const extraFieldUserSelections: { extraFieldKey: 'user-selection', extraFieldValue: string }[] = this.messageList
                    .filter(m => ItemType.isMessage(m) && m.sendToChat && m.message)
                    .flatMap(m => {
                      const item = m as BaseMessage;
                      const ISOTime = `(Timestamp ${new Date(item.timestamp || Date.now()).toISOString()} UTC)`;

                      if (ItemType.isTransactionMessage(item) && item.issues?.length) {
                        return item.issues.map(issue => {
                          const message = `${item.message}: ${issue} ${ISOTime}`;
                          const text = SYSTEM_MESSAGE_PREFIX && !item.noSystemPrefix ? `${SYSTEM_MESSAGE_PREFIX} ${message}` : message;
                          return { extraFieldKey: 'user-selection', extraFieldValue: text };
                        });
                      }

                      const message = SYSTEM_MESSAGE_PREFIX && !item.noSystemPrefix ? `${SYSTEM_MESSAGE_PREFIX} ${item.message} ${ISOTime}` : `${item.message} ${ISOTime}`;
                      return {
                        extraFieldKey: 'user-selection',
                        extraFieldValue: message,
                      };
                    });

                  const { code, message } = await plsInstance?.requestVoice({
                    description,
                    isGuest,
                    guestObj: guestObj as any,
                    extraFields: [...this.extraTransactionInfo, { extraFieldKey: 'query', extraFieldValue: this.ticketSubject }, ...extraFieldUserSelections],
                    ticketId: this.activeConversations?.selected?.id,
                    callbacks: {
                      onReady: (device: any) => {},
                      onError: (e: any) => {
                        const dialog = this.$dialog({
                          content: e.message,
                          buttons: [{
                            name: 'OK',
                            callback: () => { dialog.close(); },
                          }],
                        });
                      },
                      onConnect: (connect: any) => voiceComponent?.handleConnected(),
                      onDisconnect: (conn: any) => {
                        dialog2.close();
                        sendToParrent('CLOSE');
                      },
                    },
                  });
                  if (code !== 10000) {
                    const dialog3 = this.$dialog({
                      content: message,
                      buttons: [{
                        name: 'OK',
                        callback: () => { dialog3.close(); },
                      }],
                    });
                  }
                } catch (e) {
                  console.error('e: ', e);
                  const dialog4 = this.$dialog({
                    content: 'Something went wrong',
                    buttons: [{
                      name: 'OK',
                      callback: () => { dialog4.close(); },
                    }],
                  });
                }
              }}
              onClose={() => {
                plsInstance?.hangUpVoice();
                dialog2.close();
                reportingService.reset();
                sendToParrent('CLOSE');
              }}
              onDestroy={() => {
                plsInstance?.hangUpVoice();
              }}
            />,
          });
        },
      }],
    });
  }

  get activeConversationBack () {
    if (this.isActiveConversationSelected) {
      return this.hideActiveConversation;
    }
    if (this.showConversationHeader) {
      return (evt: Event) => {
        evt?.preventDefault();
        this.currentStep = stepEnum.ActiveConversation;
      };
    }
    return null;
  }

  get isActiveConversationSelected () {
    return Boolean(this.activeConversations?.selected);
  }

  get isActiveConversationSelectedLiveChat () {
    return Boolean(this.activeConversations?.liveChatTicket);
  }

  hideActiveConversation (fromHistoryListener = false) {
    if (this.isActiveConversationSelectedLiveChat) {
      Bridge.minimize({ avoidNoop: true });
      return;
    }
    const { backListener } = this.activeConversations;
    backListener && window.removeEventListener('popstate', backListener as any);
    if (!fromHistoryListener) this.$router.replace('#');

    this.activeConversations = activeConversation({ ...this.activeConversations, selected: null, backListener: null, route: '' });
    this.currentStep = this.activeConversations.previousStep;
  }

  async resolveActiveConversation () {
    const { total, tickets = [] } = await PleasedApi.getActiveConversations().catch(() => ({ total: 0, tickets: [] }));
    if (!total || !tickets.length) {
      this.categoryMessage && this.messageList.push(this.categoryMessage);
      return;
    }

    const getComment = ({ latestComment }: PleasedModel.ActiveTicket) => {
      if (!latestComment) return '';

      const { voice, body, authorName, authorType } = latestComment;
      if (voice) {
        return `Voice Call of ${formatDuration(intervalToDuration({ start: 0, end: voice.duration * 1000 }), { format: ['minutes', 'seconds'] })}`;
      }
      const author = authorType === 'AGENT' ? authorName : 'You';
      return author ? `${author}: ${body}` : body;
    };

    this.activeConversations = activeConversation({
      total,
      conversations: tickets.map(t => ({
        id: t.id,
        title: t.subject,
        subtitle: `Ticket #: ${t.id}`,
        description: getComment(t),
        newMessages: t.commentCount,
        updatedAt: t.updatedAt,
      })),
    });

    this.currentStep = stepEnum.ActiveConversation;
  }

  showConversation (selected: Conversation) {
    const route = `#active-convo-${selected.id || String(Math.random()).slice(2, 10)}`;
    const backListener = (e?: PopStateEvent) => {
      this.hideActiveConversation(true);
      // The event listener is removed in another callback.
    };
    window.addEventListener('popstate', backListener);

    this.activeConversations = activeConversation({ ...this.activeConversations, selected, backListener, route });
    this.activeConversations.previousStep = this.currentStep;
    this.currentStep = stepEnum.RuleEngine;
    this.showLoggedInOptions.showCall = this.showLoggedInOptions.showCall && PleasedChatClient.isVoiceChatSupported;
    this.$router.push(`/${route}`);
    this.getActiveConversationComments(selected);
    selected.id && reportingService.selectedActiveConversation(selected.id);
  }

  async getActiveConversationComments (selected: Conversation) {
    this.activeConvoComments = [createTypingMessage()];
    const comments = await PleasedApi.getActiveConversationComments(selected.id as number).then(r => r.data.comments).catch((e) => {
      console.error(e);
      return [] as PleasedModel.ActiveTicketComment[];
    });

    this.activeConvoComments = comments.flatMap(c => {
      // The logic can be improved here. We are parsing the HTML of
      // all the comments, instead we should know which comments are safe to parse from BE
      // or the parser should be moved to BE>
      const parsed = c.bodyHtml?.trim() && autoParse(c.bodyHtml);
      let messages: BaseMessage[] = [];
      if (parsed && parsed.length) {
        messages = parsed.map(m => spawnMessage({
          type: MessageType.DEFAULT,
          memberType: m.authorType === 'AGENT' ? MemberType.AGENT : MemberType.VISITOR,
          sendToChat: false,
          noSystemPrefix: true,
          message: m.message,
          timestamp: m.timestamp?.valueOf(),
        }));
      }
      const message = spawnMessage({
        type: MessageType.DEFAULT,
        message: c.body,
        noSystemPrefix: true,
        sendToChat: false,
        memberType: c.authorType === 'AGENT' ? MemberType.AGENT : MemberType.VISITOR,
      });
      if (c.attachments?.length) {
        const attachmentMessages = c.attachments.map(a => spawnMediaMessage({ attachment: { name: a.fileName, url: a.url, mimeType: a.contentType },
          memberType: c.authorType === 'AGENT' ? MemberType.AGENT : MemberType.VISITOR,
        }));
        if (c.body === 'File Upload' || !(message?.message || '').trim() || messages.length) return [...messages, ...attachmentMessages];

        return [message, ...attachmentMessages];
      }
      return messages.length ? messages : message;
    });
  }

  startOrResumeNewConversation () {
    const { messageList } = this;
    if (!messageList.length) { this.categoryMessage && this.messageList.push(this.categoryMessage); }
    this.currentStep = stepEnum.WaitRuleEngine;
    this.$nextTick(this.scrollMsgListToEnd);
  }

  async sendActiveConversationComment (commentText: string, ticket: Conversation) {
    const typing = createTypingMessage(null, MemberType.VISITOR);
    this.activeConvoComments = [...this.activeConvoComments, typing];
    const comment = await PleasedApi.addTicketComment({ comment: commentText, ticketId: ticket.id as number });
    let activeComments = [...this.activeConvoComments];
    const loadingIdx = findMessageIndex(activeComments, typing);
    const hasLoading = loadingIdx >= 0;
    if (hasLoading) { activeComments.splice(loadingIdx, 1); }

    if (comment) {
      const noticeId = 'active-convo-follow-up-notice';
      activeComments = deleteMessage(activeComments, { id: noticeId });
      activeComments.push(spawnUserSystemMessage({ message: commentText }));
      activeComments.push(createNotice({
        id: noticeId,
        message: this.$t('notice.active_conversation.post_followup') as string,
      }));
    }

    this.activeConvoComments = activeComments;
    const activeConvo = this.activeConversations.conversations.find(convo => convo.id === ticket.id);
    if (activeConvo) {
      activeConvo.updatedAt = Date.now();
      activeConvo.description = this.$t('page.active_conversation.comment_from_user', { ticketComment: commentText }) as string;
    }
  }

  async sendActiveConversationFile (file: File, ticket: Conversation) {
    const typing = createTypingMessage(null, MemberType.VISITOR);
    this.activeConvoComments = [...this.activeConvoComments, typing];
    await PleasedApi.addAttachmentComment({ file, ticketId: ticket.id as number });
    const activeConvo = this.activeConversations.conversations.find(convo => convo.id === ticket.id);
    if (activeConvo) {
      activeConvo.description = this.$t('page.active_conversation.comment_from_user', { ticketComment: this.$t('page.active_conversation.comment_when_file_sent') }) as string;
    }
    this.getActiveConversationComments(ticket);
  }

  /**
   * @event ActiveConversations#show:all
   */
  goToMyRequests () {
    emitOpenMyRequest(true);
  }
}
